// /* global google */

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Home } from "./views/Home/Home";
import api from "./Services/Api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./index.css";
import { calculateDistance } from "assets/helpers";

export default class App extends Component {
    state = {
        estabelecimentos: {},
        estabelecimentosFiltered: [],
        categorias: [],
        estabelecimentosFavoritos: [],
        userLocation: { lat: 32, lng: 32 },
        mapCenter: { lat: 32, lng: 32 },
        categoriaSelected: null,
        filterText: ""
    };

    response = null;
    isFirst = true;

    static displayName = App.name;

    async componentDidMount() {
        await this.loadCurrentPosition();
        this.loadEstabelecimentos();
        this.loadCategorias();
        this.loadFavoritos();
    }

    loadCurrentPosition = async () => {
        navigator.geolocation.getCurrentPosition(
            position => {
                const { latitude, longitude } = position.coords;

                this.setState({
                    userLocation: { lat: latitude, lng: longitude },
                    mapCenter: { lat: latitude, lng: longitude }
                });
            }
        );
    }

    onMapMove(center) {
        // let estabelecimentos = [];
        // const {estabelecimentosFiltered} = this.state;
        // for (const [key] of Object.entries(this.state.estabelecimentos)) {
        //     const value = this.state.estabelecimentos[key];
        //     const estabelecimentoLatLng = { lat: value.LATITUDE, lng: value.LONGITUDE };
        //     if (this.state.categoriaSelected) {
        //             if((value.NOVA_CATEGORIA.toUpperCase().match(
        //                 this.state.categoriaSelected.toUpperCase()
        //             ) &&
        //                 value.NOVA_CATEGORIA.toUpperCase().match(
        //                     this.state.categoriaSelected.toUpperCase()
        //                 ).length > 0))

        //         if(this.isWithinDistance(estabelecimentoLatLng, center))
        //             estabelecimentosFiltered.push(value);
        //     } else {
        //         if (this.isWithinDistance(estabelecimentoLatLng, center)) {
        //             estabelecimentosFiltered.push(value);
        //         }
        //     }
        // }

        // for (let i = 0; i < estabelecimentosFiltered.length; i++) {

        //     let estabelecimento = estabelecimentosFiltered[i];
        //     const estabelecimentoLatLng = { lat: estabelecimento.LATITUDE, lng: estabelecimento.LONGITUDE };

        //     if(this.isWithinDistance(estabelecimentoLatLng, center))
        //         estabelecimentos.push(estabelecimento);
        // }

        this.setState({
            mapCenter: center
        }, () => this.filtrar(this.state.filterText, this.state.categoriaSelected ? this.state.categoriaSelected.nome : null));
    }

    loadEstabelecimentos = async () => {
        this.response = await api.get("/estabelecimentos.json");
        let estabelecimentosFiltered = [];

        for (const [key] of Object.entries(this.response.data)) {
            const value = this.response.data[key];
            if (value) {
                const estabelecimentoLatLng = { lat: value.LATITUDE, lng: value.LONGITUDE };
                if (this.isWithinDistance(estabelecimentoLatLng)) {
                    estabelecimentosFiltered.push(value);
                }
            }
        }
        //this.isFirst = false;
        this.setState({
            estabelecimentos: this.response.data,
            estabelecimentosFiltered,
        });
    };

    loadFavoritos = () => {
        const favorites = localStorage.getItem('favoritos') || '[]';
        this.setState({
            estabelecimentosFavoritos: JSON.parse(favorites),
        });
    }

    isWithinDistance(estabelecimentoLatLng, center = this.state.mapCenter, meters = 10000) {
        return calculateDistance(estabelecimentoLatLng, center) < meters;
    }

    setUserLocation = (location) => {
        this.setState({
            userLocation: location
        })
    }

    setFilterText = val => {
        this.setState({ filterText: val });
    };

    loadCategorias = async () => {
        //let lat;
        //let lng;

        // navigator.geolocation.getCurrentPosition(
        //     position => {
        //         //const { latitude, longitude } = position.coords;
        //         //lat = latitude;
        //         //lng = longitude;    
        //         // var geocoder = new google.maps.Geocoder();
        //         // geocoder.geocode({'location': {lat: lat, lng: lng}},
        //         // (result, status) => {
        //         //     console.log(result, status);
        //         //     const components = result[0].address_components;
        //         //     let estado = "";
        //         //     components.forEach(element => {
        //         //         element.types.forEach(type => {
        //         //             if ( type === "administrative_area_level_1" ){
        //         //                 estado = element.long_name;
        //         //                 return;
        //         //             }
        //         //         })
        //         //         if ( estado !== "" ) return;
        //         //     });
        //         //     let uf = ""
        //         //     switch (estado) {
        //         //         case "Acre": uf = "AC"; break;
        //         //         case "Alagoas": uf = "AL"; break;
        //         //         case "Amazonas": uf = "AM"; break;
        //         //         case "Amapá": uf = "AP"; break;
        //         //         case "Bahia": uf = "BA"; break;
        //         //         case "Ceará": uf = "CE"; break;
        //         //         case "Distrito Federal": uf = "DF"; break;
        //         //         case "Espírito Santo": uf = "ES"; break;
        //         //         case "Goiás": uf = "GO"; break;
        //         //         case "Maranhão": uf = "MA"; break;
        //         //         case "Mato Grosso": uf = "MT"; break;
        //         //         case "Mato Grosso do Sul": uf = "MS"; break;
        //         //         case "Minas Gerais": uf = "MG"; break;
        //         //         case "Pará": uf = "PA"; break;
        //         //         case "Paraíba": uf = "PB"; break;
        //         //         case "Paraná": uf = "PR"; break;
        //         //         case "Pernambuco": uf = "PE"; break;
        //         //         case "Piauí": uf = "PI"; break;
        //         //         case "Rio de Janeiro": uf = "RJ"; break;
        //         //         case "Rio Grande do Norte": uf = "RN"; break;
        //         //         case "Rio Grande do Sul": uf = "RS"; break;
        //         //         case "Rondônia": uf = "RO"; break;
        //         //         case "Roraima": uf = "RR"; break;
        //         //         case "Santa Catarina": uf = "SC"; break;
        //         //         case "São Paulo": uf = "SP"; break;
        //         //         case "Sergipe": uf = "SE"; break;
        //         //         case "Tocantins": uf = "TO"; break;
        //         //         default: uf = ""; break;
        //         //     }
        //         //     console.log(uf);
        //         // })
        //     }
        // );


        const response = await api.get("/categorias.json");
        const listaCategorias = [];
        const listanomes = [];
        //console.log("categorias", response)
        let categoryList = [];


        for (let [key] of Object.entries(response.data)) {
            let data = { ...response.data[key], nome: key }
            listaCategorias.push(data);
            listanomes.push(data.nome);
        }

        categoryList.push(listaCategorias[listanomes.indexOf("FARMÁCIAS")]);
        categoryList.push(listaCategorias[listanomes.indexOf("POSTOS DE COMBUSTÍVEIS")]);
        categoryList.push(listaCategorias[listanomes.indexOf("RESTAURANTES")]);
        categoryList.push(listaCategorias[listanomes.indexOf("SUPERMERCADOS")]);
        categoryList.push(listaCategorias[listanomes.indexOf("OUTROS")]);

        this.setState({ categorias: categoryList });
    };

    favoritar(selectedMkr) {
        let listaFavoritos = this.state.estabelecimentosFavoritos;
        let existeFavorito = false;

        for (let i = 0; i < listaFavoritos.length; i++) {
            if (listaFavoritos[i] === selectedMkr) {
                existeFavorito = true;
                break;
            }
        }

        if (existeFavorito) {
            listaFavoritos = listaFavoritos.filter((ele) => ele !== selectedMkr);
        } else {
            listaFavoritos.push(selectedMkr)
        }

        localStorage.setItem('favoritos', JSON.stringify(listaFavoritos));
        this.setState({ estabelecimentosFavoritos: listaFavoritos });
    }

    filtrar(searchstring, categoria = null) {
        const dados = this.state.estabelecimentos;
        let results = [];
        if (searchstring || categoria) {
            for (let [key] of Object.entries(dados)) {
                const value = dados[key];
                if (value) {
                    const {
                        BAIRRO='',
                        LOGRADOURO='',
                        NOME_CIDADE='',
                        NOME_REDUZIDO='',
                        NOVA_CATEGORIA='',
                        SUB_CATEGORIA='',
                        LATITUDE,
                        LONGITUDE
                    } = value;
                    const estabelecimentoLatLng = { lat: LATITUDE, lng: LONGITUDE };

                    if (categoria !== null) {

                        if ((NOVA_CATEGORIA.toUpperCase().match(
                            categoria.toUpperCase()
                        ) &&
                            NOVA_CATEGORIA.toUpperCase().match(
                                categoria.toUpperCase()
                            ).length > 0))

                            if (this.isWithinDistance(estabelecimentoLatLng))
                                results.push(value);
                    } else {
                        if (
                            (BAIRRO.toUpperCase().match(searchstring.toUpperCase()) &&
                                BAIRRO.toUpperCase().match(searchstring.toUpperCase())
                                    .length > 0) ||
                            (LOGRADOURO.toUpperCase().match(
                                searchstring.toUpperCase()
                            ) &&
                                LOGRADOURO.toUpperCase().match(
                                    searchstring.toUpperCase()
                                ).length > 0) ||
                            (NOME_CIDADE.toUpperCase().match(
                                searchstring.toUpperCase()
                            ) &&
                                NOME_CIDADE.toUpperCase().match(
                                    searchstring.toUpperCase()
                                ).length > 0) ||
                            (NOME_REDUZIDO.toUpperCase().match(
                                searchstring.toUpperCase()
                            ) &&
                                NOME_REDUZIDO.toUpperCase().match(
                                    searchstring.toUpperCase()
                                ).length > 0) ||
                            (SUB_CATEGORIA.toUpperCase().match(
                                searchstring.toUpperCase()
                            ) &&
                                SUB_CATEGORIA.toUpperCase().match(
                                    searchstring.toUpperCase()
                                ).length > 0) ||
                            (NOVA_CATEGORIA.toUpperCase().match(
                                searchstring.toUpperCase()
                            ) &&
                                NOVA_CATEGORIA.toUpperCase().match(
                                    searchstring.toUpperCase()
                                ).length > 0)
                        ) {
                            if (this.isWithinDistance(estabelecimentoLatLng))
                                results.push(value);
                        } else {
                            // results = dados;
                        }
                    }
                }
            }
        } else {
            for (const [key] of Object.entries(dados)) {
                const value = dados[key];
                if (value) {
                    const estabelecimentoLatLng = { lat: value.LATITUDE, lng: value.LONGITUDE };
                    if (this.isWithinDistance(estabelecimentoLatLng)) {
                        results.push(value);
                    }
                }
            }
        }

        this.setState({ estabelecimentosFiltered: results, categoriaSelected: categoria });
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={props => (
                            <Home
                                {...props}
                                estabelecimentos={this.state.estabelecimentosFiltered}
                                filtrar={(searchstring, categoria) =>
                                    this.filtrar(searchstring, categoria)
                                }
                                favoritar={this.favoritar.bind(this)}
                                estabelecimentosFavoritos={this.state.estabelecimentosFavoritos}
                                userLocation={this.state.userLocation}
                                mapCenter={this.state.mapCenter}
                                onMapMove={this.onMapMove.bind(this)}
                                setUserLocation={this.setUserLocation.bind(this)}
                                categorias={this.state.categorias}
                                setFilterText={this.setFilterText.bind(this)}
                                filterText={this.state.filterText}
                            />
                        )}
                    />
                </Switch>
            </BrowserRouter>
        );
    }
}